import 'velocity-animate';

var $accordionPanels = $('.js-accordion').find('.js-accordion-description'),
    $accordionTitle = $('.js-accordion').find('.js-accordion-title'),
    allPanels = $('.js-accordion-panel');

$accordionPanels.hide();

$accordionTitle.on('click', function () {
    if (!$(this).parent().hasClass('is-active')) {
        $(this).closest('.js-accordion').addClass('is-open');

        allPanels.removeClass('is-active');
        $accordionPanels.velocity('slideUp', { duration: 200 });

        $(this).parent().addClass('is-active');
        $(this).next().velocity('slideDown', { duration: 200 });
    } else {
        $(this).next().velocity('slideUp', { duration: 200 });
        allPanels.removeClass('is-active');
        $(this).closest('.js-accordion').removeClass('is-open');
    }

    return false;
});